const SELECTOR = "[data-tw-wood-selector]";

function initWoodSelector(root: ParentNode = document) {
  const sections = Array.from(root.querySelectorAll<HTMLElement>(SELECTOR));
  for (const section of sections) {
    if (section.dataset.initialized === "true") continue;
    section.dataset.initialized = "true";
    setupSection(section);
  }
}

function setupSection(section: HTMLElement) {
  const swatches = Array.from(section.querySelectorAll<HTMLElement>("[data-swatch]"));

  for (const swatch of swatches) {
    swatch.addEventListener("touchstart", (e) => {
      e.preventDefault();
      const wasActive = swatch.classList.contains("is-active");

      // Deactivate all swatches
      for (const s of swatches) {
        s.classList.remove("is-active");
        setActiveState(s, false);
      }

      // Toggle current
      if (!wasActive) {
        swatch.classList.add("is-active");
        setActiveState(swatch, true);
      }
    }, { passive: false });
  }
}

function setActiveState(swatch: HTMLElement, active: boolean) {
  const images = swatch.querySelectorAll<HTMLElement>("img");
  const tooltip = swatch.querySelector<HTMLElement>("[data-tooltip]");

  if (images.length >= 2) {
    const defaultImg = images[0];
    const hoverImg = images[1];

    if (active) {
      defaultImg.classList.add("!opacity-0");
      hoverImg.classList.add("!opacity-100");
    } else {
      defaultImg.classList.remove("!opacity-0");
      hoverImg.classList.remove("!opacity-100");
    }
  }

  if (tooltip) {
    if (active) {
      tooltip.classList.add("!opacity-100");
    } else {
      tooltip.classList.remove("!opacity-100");
    }
  }
}

export { initWoodSelector };
